<template>
  <vs-popup
    class="triangle-test-create-popup"
    id="popup"
    :title="updateMode ? 'Update Test' : 'Create Test'"
    @close="open = false"
    :active.sync="open"
    :buttons-hidden="true"
  >
    <vx-card no-shadow>
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form
          id="create-triangle-test-popup"
          @submit.prevent="handleSubmit(createTriangleTest)"
          autocomplete="off"
        >
          <vx-card title="FORMULATIONS" class="mb-6" v-if="!updateMode">
            <div slot="no-body" class="p-4">
              <div class="vx-col md:w-1/3 sm:w-1/2 w-full mb-4">
                <label class="text-sm font-semibold mb-1 block"
                  >Search Formulation</label
                >
                <vs-input
                  type="search"
                  placeholder="Search..."
                  v-model="formulationSearchTxt"
                  @input="searchFormulation(formulationSearchTxt)"
                  class="w-full"
                />
              </div>

              <vs-table
                id="wo-list-table"
                :data="formulationList"
                :sst="true"
                v-model="selectedFormulation"
                @selected="handleSelectedFormulation"
                :multiple="false"
                :selectable="true"
                class="rounded-lg overflow-hidden"
              >
                <template slot="thead">
                  <vs-th class="text-xs">FORMULATION CODE</vs-th>
                  <vs-th class="text-xs">NAME</vs-th>
                  <vs-th class="text-xs">TYPE</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr
                    v-for="(tr, indextr) in data"
                    :key="indextr"
                    :data="tr"
                    style="cursor: pointer"
                  >
                    <vs-td :data="tr.formulation_code || tr.code">
                      {{ tr.formulation_code || tr.code }}
                    </vs-td>
                    <vs-td :data="tr.name">{{ tr.name }}</vs-td>
                    <vs-td :data="tr.formulation_type || tr.type">
                      {{ tr.formulation_type || tr.type }}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </vx-card>

          <div class="vx-card p-4 border rounded-lg">
            <div class="vx-row gap-4">
              <div class="vx-col w-full md:w-1/2 mb-4">
                <label class="text-sm font-semibold mb-1 block">Status</label>
                <ValidationProvider
                  rules="required"
                  name="Status"
                  v-slot="{ errors }"
                >
                  <v-select
                    :options="statusOptions"
                    v-model="form.status"
                    :reduce="(option) => option.value"
                    label="label"
                    placeholder="Select status"
                    @input="updateStatus"
                    :clearable="false"
                    class="w-full"
                  />
                  <span v-if="errors[0]" class="text-danger text-sm">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>

              <div class="vx-col w-full md:w-1/2 mb-4">
                <label class="text-sm font-semibold mb-1 block"
                  >Random Work Orders</label
                >
                <ValidationProvider
                  :vid="`selected_different_batch`"
                  :name="`selected_different_batch`"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-select
                    :options="form.presented_batches"
                    v-model="form.selected_different_batch"
                    :clearable="false"
                    class="w-full"
                    placeholder="Select Work Order"
                    :disabled="!canEdit"
                  />
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

              <div class="vx-col w-full md:w-1/2 mb-4">
                <label class="text-sm font-semibold mb-1 block"
                  >Difference Level</label
                >
                <ValidationProvider
                  :vid="`difference_level`"
                  :name="`difference_level`"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-select
                    :options="['1', '2', '3', '4']"
                    v-model="form.difference_level"
                    :clearable="false"
                    class="w-full"
                    placeholder="Select Level"
                    :disabled="!canEdit"
                  />
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

              <div class="vx-col w-full mb-4">
                <label class="text-sm font-semibold mb-1 block"
                  >Difference Description</label
                >
                <ValidationProvider
                  :vid="`difference_description`"
                  :name="`difference_description`"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <vs-textarea
                    v-model="form.difference_description"
                    class="w-full"
                    placeholder="Describe the difference..."
                    :disabled="!canEdit"
                  />
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

              <div class="vx-col w-full">
                <label class="text-sm font-semibold mb-1 block">Note</label>
                <vs-textarea
                  v-model="form.notes"
                  class="w-full"
                  placeholder="Add a note..."
                  :disabled="!canEdit"
                />
              </div>
            </div>
            <FilePreviewGallery
              :removable="true"
              :files="form.file_paths"
              @remove="removeFile"
            />

            <br />

            <multi-file-uploader
              v-if="canEdit"
              v-on:onSetFileName="onSetFiles($event)"
              :file="''"
              file_path="ccp-item/attachments"
              :condition="true"
            />
          </div>
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button
              icon-pack="feather"
              icon="icon-save"
              button="submit"
              color="primary"
              class="ml-auto mt-2"
              v-can="'create-edit-quality-control-tastings'"
            >
              Submit
            </vs-button>

            <vs-button
              @click="resetForm"
              icon-pack="feather"
              icon="icon-x"
              color="danger"
              class="ml-2 mt-2"
            >
              Clear
            </vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { RepositoryFactory } from "@/repository/RepositoryFactory";
import SuccessMessage from "@/mixins/SuccessMessage";
import ErrorMessages from "@/mixins/ErrorMessages";
import moment from "moment";
import FilePreviewGallery from "@/components/shared/FilePreviewGallery.vue";

const FormulationsRepository = RepositoryFactory.get("formulations");
const TriangleTestsRepository = RepositoryFactory.get("triangle_tests");

function initialState() {
  return {
    open: false,
    id: "",
    form: {
      formulation_id: null,
      presented_batches: [],
      selected_different_batch: null,
      difference_description: "",
      file_paths: [],
      notes: "",
    },
    updateMode: false,
    formulationList: [],
    selectedFormulation: null,
    formulationSearchTxt: "",
    difference_level: null,
    statusOptions: [],
  };
}
export default {
  data() {
    return initialState();
  },
  components: {
    "v-select": vSelect,
    FilePreviewGallery,
  },
  mixins: [SuccessMessage, ErrorMessages],
  methods: {
    async openPopup(id = null) {
      try {
        await Object.assign(this.$data, initialState());
        if (id != null) {
          this.id = id;
          this.updateMode = true;
          await this.fetchTriangleTestDetails();
          await this.fetchStatusList();
        }
        this.open = true;
      } catch (error) {}
    },
    async createTriangleTest() {
      try {
        this.$vs.loading();
        if (this.updateMode) {
          const response = await TriangleTestsRepository.updateTriangleTest(
            this.id,
            this.form
          );
        } else {
          const response = await TriangleTestsRepository.createTriangleTest(
            this.form
          );
        }
        this.$emit("refresh");
      } catch (e) {
      } finally {
        this.$vs.loading.close();
        this.open = false;
      }
    },
    async fetchTriangleTestDetails() {
      const response = await TriangleTestsRepository.getTriangleTestDetails(
        this.id
      );
      this.mapTriangleTestToForm(response.data.data);
    },
    async fetchStatusList() {
      try {
        const response =
          await TriangleTestsRepository.getTriangleTestStatusList();
        this.statusOptions = response.data.data;
      } catch (e) {}
    },
    async updateStatus(status) {
      try {
        this.$vs.loading();
        await TriangleTestsRepository.updateTriangleTestStatus(this.id, {
          status: status,
        });
        this.$emit("refresh");
      } catch (error) {
        this.convertAndNotifyError(e);
      } finally {
        this.$vs.loading.close();
      }
    },
    async handleSelectedFormulation(selected) {
      this.form.formulation_id = selected.id;
      await this.fetchRandomWo();
    },
    async fetchRandomWo() {
      try {
        this.$vs.loading();
        const response = await TriangleTestsRepository.getRandomWo(
          this.form.formulation_id
        );
        const workOrders = response.data.data.work_orders || [];
        this.form.presented_batches = workOrders.map((item) => item.code);
      } catch (e) {
        this.convertAndNotifyError(e);
      } finally {
        this.$vs.loading.close();
      }
    },
    async fetchFormulations(searchText = "") {
      const response = await FormulationsRepository.getListWithElasticSearch(
        1,
        `filter[search]=${searchText}`,
        20,
        "-created_at"
      );
      this.formulationList = response.data.data;
    },
    searchFormulation: _.debounce(async function (search) {
      await this.fetchFormulations(search);
    }, 1000),
    mapTriangleTestToForm(data) {
      if (!data) return;

      this.form = {
        formulation_id: data.formulation_id || null,
        presented_batches: Array.isArray(data.presented_batches)
          ? [...data.presented_batches]
          : [],
        selected_different_batch: data.selected_different_batch || null,
        difference_description: data.difference_description || "",
        difference_level: data.difference_level || null,
        notes: data.notes,
        file_paths: Array.isArray(data.file_paths) ? [...data.file_paths] : [],
        status: data.status,
      };
    },
    onSetFiles(file_path) {
      this.form.file_paths.push(file_path);
    },
    resetForm() {
      this.form = {
        formulation_id: null,
        presented_batches: [],
        selected_different_batch: null,
        difference_description: "",
        difference_level: null,
        note: "",
      };
      this.selectedFormulation = null;
      this.formulationSearchTxt = "";
    },
  },
  computed: {
    canEdit() {
      return this.$can && this.$can("create-edit-quality-control-tastings");
    },
  },
};
</script>

<style scoped>
.triangle-test-create-popup >>> .vs-popup {
  /*min-height: 50% !important;*/
  min-width: 80% !important;
}
</style>
